import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    imports: [
      RouterOutlet
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: true

})
export class AppComponent {
  title = 'conexao-coaf-app';
}
